<div *transloco="let t; prefix: scope" class="relative">
  <ul rmaOverflowScroll rmaScrollSync #scroller="rmaOverflowScroll" class="m-0 flex snap-x list-none gap-3 overflow-x-auto p-0 pt-2 pb-4">
    @if (showAddSlot()) {
      <li class="w-36 shrink-0 snap-start md:min-w-48 md:grow md:basis-0">
        <rma-add-agent-slot />
      </li>
    }

    @for (agent of agents(); track agent.agentCode) {
      <li class="w-36 shrink-0 snap-start md:min-w-48 md:grow md:basis-0">
        <rma-agent-card [agent]="agent" (removeAgent)="removeAgent.emit(agent.agentCode)" />
      </li>
    }
  </ul>

  <rma-scroll-chevron [canScroll]="scroller.canScroll()" [label]="t('cardsRow.scroll')" (scrolled)="scroller.scrollRight()" />
</div>
